import { createPortal } from "react-dom";

const ModalWithPortal = ({ isOpenPortal, setIsOpenPortal, children, setLocation }) => {
  if (!isOpenPortal) return null;

  return createPortal(
    <div
      style={{
        width: "100%",
        height: "100vh",
        top: 0,
        position: "absolute",
        left: 0,
        overflow: "hidden",
        boxSizing: "border-box",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100vh",
          top: 0,
          position: "absolute",
          left: 0,
          zIndex: "99999999999999999999999999999999999999",
          backgroundColor: "rgba(0, 0, 0, 1)",
        }}
        onClick={() => (setLocation !== undefined ? setLocation() && setIsOpenPortal(false) : setIsOpenPortal(false))}
      />
      {children}
    </div>,

    document.getElementById("canvas"),
  );
};

export default ModalWithPortal;
